import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Modal, TextContainer, DataTable, Badge, TextStyle } from '@shopify/polaris';
import { ta } from 'utils';

const propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,

  columns: PropTypes.array.isRequired,
  records: PropTypes.array.isRequired,
  errors: PropTypes.array.isRequired,

}
const defaultProps = {}

const InformativeModal = (props) => {
  const currentDate = new Date();

  const errorsFound = props.errors.length > 0;

  console.log("InformativeModal", props)

  // Dynamically build row, cells are taken from all values on the record object
  const rows = props.records.map((record) => (
    Object.keys(record).map((valueName) => {
      console.log("record", record);
      const value = record[valueName];
      if(typeof(value) === "boolean"){
        return (
          <Badge status={ value ? "info" : "warning" }>
            { value ? I18n.t("true") : I18n.t("false") }
          </Badge>
        )
      }
      else{
        return record[valueName];
      }
    })
  )); // Depends on structure of records

  return (
    <div>
      <Modal
        open={props.open}
        large
        onClose={props.onClose}
        title={`${props.title} - ${I18n.l("time.formats.unimart_date", currentDate.toISOString())}`}
      >
        <Modal.Section>
          <TextContainer>
            { (props.records.length <= 0 && !errorsFound) && "No se encontraron resultados" }

            {/* Records if present (likely success) */}
            { props.records.length > 0 &&
              <DataTable
                columnContentTypes={ props.columns.map((column) => 'text' ) }
                headings={ props.columns }
                rows={ rows }
              />
            }

            {/* Errors if any */}
            { errorsFound && props.errors.map((error, index) => (
              <p>
                <TextStyle variation="negative" key={index}>
                  {error}
                </TextStyle>
              </p>
            )) }  
            
          </TextContainer>
        </Modal.Section>
      </Modal>
    </div>
  )
}

InformativeModal.propTypes = propTypes;
InformativeModal.defaultProps = defaultProps;
export default InformativeModal;
